import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input, Radio, DatePicker,Select } from "antd";
import InputCPF from "../InputCpf";


import service from "./services";

const { Option } = Select;


const Dependencia = ({
    nomePrefix = [],
    children,
    form,
  }) => {
    
    const [listaTipoDependencia, setListaTipoDependencia] = useState([]);
    const [listaGrauParentesco, setListaGrauParentesco] = useState([]);
    const [listaMotivoInicioDependencia, setListaMotivoInicioDependencia] = useState([]);
    const [listaMotivoFimDependencia, setListaMotivoFimDependencia] = useState([]);
    

    const getScrollableParent = (node) => {
      if (!node) return document.body;
    
      let parent = node.parentElement;
    
      while (parent) {
        const style = window.getComputedStyle(parent);
    
        const isScrollable =
          (style.overflowY === "auto" || style.overflowY === "scroll") &&
          parent.scrollHeight > parent.clientHeight;
    
        if (isScrollable) return parent;
    
        parent = parent.parentElement;
      }
    
      return document.body;
    };
  

    useEffect(() => {
        service.listaTipoDependencia()
          .then(res => {
            console.log("Tipo dependências recebidas:", res.data);
            setListaTipoDependencia(res.data);
          })
          .catch(err => console.error("Erro ao carregar Tipo de dependências:", err));

          service.listarGrauParentesco()
          .then(res => {
            setListaGrauParentesco(res.data);
      
            const gpForm = form.getFieldValue([...nomePrefix, "grauParentesco"]);
      
            if (gpForm?.id) {
              const equivalente = res.data.find(m => m.id === gpForm.id);
      
              if (equivalente) {
                form.setFieldValue([...nomePrefix, "grauParentesco"], equivalente);
              }
            }
          })
          .catch(err => console.error("Erro ao carregar o Grau Parentesco:", err));

          service.listarMotivoInicioDependencia()
          .then(res => {
            console.log("Motivo inicio dependências recebidas:", res.data);
            setListaMotivoInicioDependencia(res.data);
          })
          .catch(err => console.error("Erro ao carregar Tipo de dependências:", err));

          service.listarMotivoFimDependencia()
          .then(res => {
            console.log("Motivo fim dependências recebidas:", res.data);
            setListaMotivoFimDependencia(res.data);
          })
          .catch(err => console.error("Erro ao carregar Tipo de dependências:", err));

      }, []);

    return (
        <>
        <Row gutter={12}>
            <Col span={6}>
              <Form.Item
                  name={[...nomePrefix, "tipoDependencia"]}
                  label="Tipo da Dependência"
                  rules={[{ required: true }]}
              >
                  <Select
                      placeholder="Selecione o tipo dependência"
                      allowClear
                      getPopupContainer={(trigger) => trigger.parentNode}
                      >
                      {listaTipoDependencia.map((d, index) => (
                        <Option key={d.nome} value={index}>
                          {d.sigla}
                        </Option>
                      ))}
                  </Select>

              </Form.Item>
            </Col>  
            <Col span={4}>
              <Form.Item
                  name={[...nomePrefix, "periodicidadeBenef"]}
                  label="Periodicidade do Benefício"
                  rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Radio value={0}>Temporária</Radio>
                  <Radio value={1}>Vitalícia</Radio>
                </Radio.Group>

              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={[...nomePrefix, "grauParentesco"]}
                label="Grau de Parentesco"
                rules={[{ required: true, message: "Selecione o grau de parentesco" }]}
                
                getValueProps={(valor) => {
                  if (!valor) return { value: undefined };

                  return {
                    value: {
                      value: valor.id,
                      label: valor.nome,
                    },
                  };
                }}
              >
                <Select
                  placeholder="Selecione"
                  allowClear
                  labelInValue
                  optionLabelProp="label"
                  getPopupContainer={(trigger) => trigger.parentNode}

                  onChange={(value) => {
                    if (!value) {
                      form.setFieldValue([...nomePrefix, "grauParentesco"], null);
                      return;
                    }

                    const objetoCompleto = listaGrauParentesco.find(
                      (m) => m.id === value.value
                    );

                    form.setFieldValue(
                      [...nomePrefix, "grauParentesco"],
                      objetoCompleto
                    );
                  }}
                >
                  {listaGrauParentesco?.map((m) => (
                    <Select.Option key={m.id} value={m.id} label={m.nome}>
                      {m.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={5}>
                  <Form.Item
                      name={[...nomePrefix, "dataInicio"]}
                      label="Data de Início da Dependência"
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        getPopupContainer={(trigger) => trigger.parentNode}
                      />
                    </Form.Item>
            </Col>

            <Col span={5}>
                  <Form.Item
                      name={[...nomePrefix, "dataFimPrevista"]}
                      label="Data Prevista para o Fim da Dependência"
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        getPopupContainer={(trigger) => trigger.parentNode}
                      />
                    </Form.Item>
            </Col>

            <Col span={5}>
                  <Form.Item
                      name={[...nomePrefix, "dataFim"]}
                      label="Data do Fim da Dependência"
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        getPopupContainer={(trigger) => trigger.parentNode}
                      />
                    </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item
                  name={[...nomePrefix, "motivoInicioDependencia"]}
                  label="Motivo do Início da Dependência"
                  rules={[{ required: true }]}
              >
                   <Select
                      placeholder="Selecione o motivo"
                      allowClear
                      getPopupContainer={(trigger) => trigger.parentNode}
                      >
                      {listaMotivoInicioDependencia.map((d, index) => (
                        <Option key={index} value={index}>
                          {d.sigla}
                        </Option>
                      ))}
                  </Select>

              </Form.Item>
            </Col> 

            <Col span={4}>
              <Form.Item
                name={[...nomePrefix, "motivoFimDependencia"]}
                label="Motivo do Fim da Dependência"
              >
                <Select
                  placeholder="Selecione"
                  allowClear
                  onChange={(motivoFimDependencia) => {
                    if (
                      motivoFimDependencia === 0 || 
                      motivoFimDependencia === "" || 
                      motivoFimDependencia === null
                    ) {
                      form.setFieldValue([...nomePrefix, "motivoFimDependencia"], undefined);
                    } else {
                      form.setFieldValue([...nomePrefix, "motivoFimDependencia"], motivoFimDependencia);
                    }
                  }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {listaMotivoFimDependencia.map((m, index) => {
                    if (!m.sigla?.trim()) return null;

                    return (
                      <Option key={index} value={index}>
                        {m.sigla}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>


        </Row>

        {children && (
            <Row gutter={12}>
            {children}
            </Row>
        )}
        </>
    );
};

export default Dependencia;
